__turbopack_context__.v({
  "accountPopover": "account-popover-module-sass-module__S0Ualq__accountPopover",
  "menu": "account-popover-module-sass-module__S0Ualq__menu",
  "signOutBtn": "account-popover-module-sass-module__S0Ualq__signOutBtn",
  "userId": "account-popover-module-sass-module__S0Ualq__userId",
  "userInfo": "account-popover-module-sass-module__S0Ualq__userInfo",
});
